module.exports = __webpack_public_path__ + "yt.svg?f91334afbba9289be742a718421eb757";